import LinearProgress from "@material-ui/core/LinearProgress";
import Grid from "@material-ui/core/Grid";

import { TravelerContainer } from "../../../../common/traveler/TravelerContainer";
import { TravelerNotesContainer } from "../../../../common/traveler/TravelerNotesContainer";
import { TravelerGroup } from "../../../../common/traveler/TravelerGroup";
import { TravelerGroupHeader } from "../../../../common/traveler/TravelerGroupHeader";
import { TravelerMasterContainer } from "../../../../common/traveler/TravelerMasterContainer";
import { TravelerMasterRow } from "../../../../common/traveler/TravelerMasterRow";
import { TravelerNotes } from "../../../../common/traveler/TravelerNotes";
import { ErrorMessage } from "../../../../common/ErrorMessage";
import { useTestPermissions } from "../../../projectQueries";
import { useTestSequenceDefinitionDetails } from "../../../testSequenceDefinitionQueries";
import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from "@material-ui/core";
import { TsdTravelerComponent } from "./TsdTravelerComponet";



export const TsdTravelerDialog = ({ id, travelerOpen, handleTraveler , handleClose}: any) => {

    const { data, isLoading, isError, error } =
        useTestSequenceDefinitionDetails(id);
    const [selectedProcedure, setSelectedProcedure] = useState("");
    const {
        data: permissions,
        isLoading: isLoadingPermissions,
        isError: isErrorPermissions,
        error: errorPermissions,
    } = useTestPermissions();
    const updateReportResult =  (reportSequence: string, procedure_execution_order:any) => {
      console.log("Selected report sequence:", reportSequence);
      setSelectedProcedure(reportSequence);
      // setValue(reportSequence)
      
    }

    // const handleClose = () => {
    //   console.log("Selected report sequence:", selectedProcedure);
    //     onClose(selectedProcedure);
      
    //   }
    if (isLoading || isLoadingPermissions) {
        return (
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                spacing={4}
            >
                <Grid item xs={12}>
                    <LinearProgress />
                </Grid>
            </Grid>
        );
    }

    if (isError) {
        return <ErrorMessage error={error} />;
    }

    if (isErrorPermissions) {
        return <ErrorMessage error={errorPermissions} />;
    }

    return (
        <Dialog
            open={travelerOpen}
            onClose={() => handleTraveler()}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            fullWidth={true}
            maxWidth={"xl"}
        >
            <DialogTitle id="scroll-dialog-title">
            Traveler {""}
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs={3}
            >

              <TextField
                id="report_sequence"
                label="Report sequence"
                name="report_sequence_select"
                disabled={false}
                select
                fullWidth
                variant="outlined"
                size="small"

              >
                {data.grouped_results?.map((rsd: any) => (
                  <MenuItem

                    key={rsd.name}
                    onClick={() =>
                      // updateReportResult(rsd.name, rsd.procedure_execution_order)
                      handleClose(rsd.name, id) 
                      
                    }
                    value={rsd.name}
                  >
                    {rsd.name}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>

          </Grid>
            </DialogTitle>
            <DialogContent dividers={true}>
               {travelerOpen && (
                    <TsdTravelerComponent tsdData= {data} id={id} selectedProcedure={selectedProcedure} />
                )}
               
            </DialogContent>
            <DialogActions>
          <Button onClick={() => handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
        </Dialog>


    );
};



